import { translate } from 'sharedreact/utils/LanguageSupport';

function getStatusText (
  numberOfSelectedItems: number,
  numberOfItems: number,
  itemIdentifier: string
): string {
  if (numberOfItems === 0) {
    return '';
  }
  // number of items => 1
  if (numberOfItems === 1) {
    if (numberOfSelectedItems === 0) {
      return translate(itemIdentifier + '.statustext.1item');
    }
    // 1 of 1 item is selected
    return translate(itemIdentifier + '.statustext.1of1itemselected');
  } else {
    // number of items > 1
    if (numberOfSelectedItems === 0) {
      return translate(itemIdentifier + '.statustext.nitems', numberOfItems);
    }
    // number of selected items > 0
    return translate(itemIdentifier + '.statustext.nofnitemsselected', numberOfSelectedItems, numberOfItems);
  }
}

const StatusTextSupport = {
  getStatusText
}

export {
  getStatusText
};

export default StatusTextSupport;
